module.exports = __webpack_public_path__ + "img/404.b4d5727b.gif";